// Importamos la librería con la base de datos local (100% offline y rápida)
import { City } from 'country-state-city';

// Extraemos TODAS las ciudades de Venezuela ('VE') en memoria
const venezuelaCities = City.getCitiesOfCountry('VE');

export const validateCountry = async (lat, lon) => {
  // 1. Validación básica de que existan los valores
  if (lat === undefined || lon === undefined || lat === null || lon === null) {
    return { isValid: false, country: "Coordenadas vacías" };
  }

  // 2. Validación de coordenadas irreales (fuera del mapa mundial)
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) {
    return { isValid: false, country: "Coordenadas irreales (fuera del mapa)" };
  }



  return { isValid: true, country: "Ubicación válida" };
};

export const getCityCoordinates = async (cityName) => {
  try {
    const searchName = cityName.toLowerCase().trim();

    // 🔥 IGUALDAD SOLO PARA MARGARITA: Tratamos "margarita" y "nueva esparta" igual
    if (searchName === "margarita" || searchName === "nueva esparta") {
      return {
        lat: 10.9967,
        lon: -63.9213,
        zoom: 10, // <--- Zoom alejado ideal para ver toda la isla de Margarita
        displayName: "Estado Nueva Esparta, Venezuela"
      };
    }

    // Si no es Margarita, buscamos en la base de datos local de la librería
    const foundCity = venezuelaCities.find(
      (city) => city.name.toLowerCase() === searchName
    );

    if (foundCity) {
      return {
        lat: parseFloat(foundCity.latitude),
        lon: parseFloat(foundCity.longitude),
        zoom: 13, // <--- Zoom normal y cercano para el resto de las ciudades
        displayName: `${foundCity.name}, Venezuela`
      };
    }

    return null; // Si no existe la ciudad
  } catch (error) {
    console.error("Error buscando la ciudad:", error);
    return null;
  }
};